import ConfigTicketRegistCustomer from "../model/ConfigTicketRegistCustomer";
import { GetOptions, promiseRequest } from "./ServiceApi";
import { ServiceApi } from "./ServiceApiWithLoading";

export default class ConfigTicketRegistCustomerApi extends ServiceApi<ConfigTicketRegistCustomer>{

    constructor() {
        super('configTicketRegistCustomer');
    }

    async getConfigTicketRegistCustomer(options: GetOptions<ConfigTicketRegistCustomer> = {}): Promise<ConfigTicketRegistCustomer> {
        return this.promiseWithLoading(super.getById(1, options));
    }

    async saveConfigTicketRegistCustomer(data: Partial<ConfigTicketRegistCustomer>) {
        return this.promiseWithLoading(super.update(1, data));
    }
}